import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";

// ────────────────────────────────────────────────
// PostHog Analytics (Production Ready)
// ────────────────────────────────────────────────
import posthog from 'posthog-js';

posthog.init('phc_bVKlQ4czuiwMgcX0DItznDrqxGYCWEwgXMRsfUDAH4f', {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only',
  capture_pageview: true,
  disable_session_recording: true,
});

// ────────────────────────────────────────────────

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);